import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Typography,
} from '@mui/material';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

interface Props {
  open: boolean;
  /** Stay in GradMap (close the modal / go to dashboard). */
  handleClose: () => void;
  /** Go to the GradMap upgrade / billing page. */
  handleUpgrade: () => void;
}

const FEATURES = [
  'College Application Manager (CAM)',
  'Auto-fill, deadlines & requirements tracking',
  'Counselor collaboration on your applications',
];

const CamUpgradeModal = (props: Props) => {
  const { open, handleClose, handleUpgrade } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableScrollLock
      container={typeof document !== 'undefined' ? document.body : undefined}
      sx={{ zIndex: 14000 }}
      PaperProps={{ sx: { borderRadius: 3, minWidth: 420, maxWidth: 520 } }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, fontSize: 20, pt: 3 }}>
        <AutoAwesomeRoundedIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
        <Box>Upgrade to unlock CAM</Box>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ textAlign: 'center', fontSize: 15, mt: 1, mb: 2, color: 'text.secondary' }}>
          Your current plan is GradMap Free, which doesn&apos;t include the College Application
          Manager. Start a 7-day free trial — no credit card required — to continue.
        </Typography>

        <Box sx={{ mt: 1 }}>
          {FEATURES.map((feature) => (
            <Box key={feature} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
              <CheckCircleRoundedIcon sx={{ fontSize: 18, color: 'success.main', mt: '2px' }} />
              <Typography sx={{ fontSize: 14 }}>{feature}</Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, px: 3 }}>
        <Button onClick={handleUpgrade} variant="contained" color="primary" sx={{ minWidth: 160, mr: 1 }}>
          Start free trial
        </Button>
        <Button onClick={handleClose} variant="outlined" color="inherit" sx={{ minWidth: 120 }}>
          Maybe later
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CamUpgradeModal;
